type MobileOS = 'Windows Phone' | 'Android' | 'iOS' | 'unknown';

interface ClientUtils {
  getMobileOperatingSystem(userAgent?: string): MobileOS;
  mountDomListeners(setDeviceAndWidth: () => void, updateOnlineStatus: () => void): void;
  removeDomListeners(setDeviceAndWidth: () => void, updateOnlineStatus: () => void): void;
  hasEmojiSupport(): boolean;
}

// Extend Window interface for vendor and opera properties
declare global {
  interface Window {
    opera?: string;
    MSStream?: unknown;
  }
}

const clientUtils: ClientUtils = {
  getMobileOperatingSystem(userAgent?: string): MobileOS {
    // adapted from https://stackoverflow.com/a/21742107/7669090
    const _userAgent = userAgent || navigator.userAgent || navigator.vendor || window.opera || '';

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(_userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(_userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(_userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  },
  // FIXME: Use passive events where support exists (see consolidated-events)
  mountDomListeners(setDeviceAndWidth: () => void, updateOnlineStatus: () => void): void {
    window.addEventListener('resize', setDeviceAndWidth);
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  },
  // FIXME: Use passive events where support exists (see consolidated-events)
  removeDomListeners(setDeviceAndWidth: () => void, updateOnlineStatus: () => void): void {
    window.removeEventListener('resize', setDeviceAndWidth);
    window.removeEventListener('online', updateOnlineStatus);
    window.removeEventListener('offline', updateOnlineStatus);
  },
  hasEmojiSupport(): boolean {
    const pixelRatio = window.devicePixelRatio || 1;
    const offset = 12 * pixelRatio;
    const node = document.createElement('canvas');

    // canvastext support
    const context = node.getContext('2d');
    if (!node.getContext || !context || typeof context.fillText !== 'function') {
      return false;
    }

    context.fillStyle = '#f00';
    context.textBaseline = 'top';
    context.font = '32px Arial';
    context.fillText('\ud83d\udc28', 0, 0); // U+1F428 KOALA
    return context.getImageData(offset, offset, 1, 1).data[0] !== 0;
  },
};

export default clientUtils;
